export function isLeftClickEvent(event) {
  return event.button === 0;
}
export function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
export var resolveToLocation = function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
};